export default class AuthenticationSettingsView {
    constructor(json) {
        this.type = json['type'];
        this.openIdConnectEnabled = json['openIdConnectEnabled'];
        this.openIdConnectConfiguration = json['openIdConnectConfiguration'];
    }
}
